export const successMessages = {
  signup: {
    post:
      "Signup is succesfull, a verification link is send to your email, Please verify your email and proceed to login",
  },
};
